import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Drawer, Stack, Typography, useTheme, } from '@mui/material';
import { SidebarItem, SidebarGroup } from './SidebarItem';
import { isOfTypeNavEntryGroup, } from './navTypes';
import { Scrollbar } from './Scrollbar';
import { useSidebar } from './SidebarContext';
import { SIDE_NAV_WIDTH } from './constants';
export const Sidebar = ({ entries, logo, appName, }) => {
    const { isMobileOpen, closeMobileSidebar } = useSidebar();
    const theme = useTheme();
    const content = (_jsx(Scrollbar, { sx: {
            height: '100%',
            '& .simplebar-content': { height: '100%' },
            '& .simplebar-scrollbar:before': { background: 'neutral.400' },
        }, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }, children: [_jsx(Box, { sx: { p: 3 }, children: _jsxs(Box, { sx: {
                            alignItems: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.04)',
                            borderRadius: 1,
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            p: '12px',
                        }, children: [_jsx("img", { src: logo.src, alt: logo.alt, style: { width: 40, height: 40 } }), _jsx(Typography, { sx: { ml: 2 }, color: 'inherit', variant: 'subtitle1', children: appName })] }) }), _jsx(Divider, { sx: { borderColor: 'neutral.700' } }), _jsx(Box, { component: 'nav', sx: { flexGrow: 1, px: 2, py: 3 }, children: _jsx(Stack, { component: 'ul', spacing: 0.5, sx: { listStyle: 'none', p: 0, m: 0 }, children: entries.map((item) => {
                            if (isOfTypeNavEntryGroup(item)) {
                                return (_jsx(SidebarGroup, { icon: item.icon, title: item.title, entries: item.entries }, item.title));
                            }
                            const entry = item;
                            return (_jsx(SidebarItem, { disabled: entry.disabled, external: entry.external, icon: entry.icon, path: entry.path, title: entry.title, permissionsRequired: entry.permissionsRequired, exact: entry.exact }, entry.title));
                        }) }) })] }) }));
    const drawerPaperSx = {
        backgroundColor: 'neutral.800',
        color: 'common.white',
        width: SIDE_NAV_WIDTH,
    };
    return (_jsxs(_Fragment, { children: [_jsx(Drawer, { anchor: 'left', onClose: closeMobileSidebar, open: isMobileOpen, slotProps: { paper: { sx: drawerPaperSx } }, sx: {
                    display: { xs: 'block', lg: 'none' },
                    zIndex: theme.zIndex.appBar,
                }, variant: 'temporary', children: content }), _jsx(Drawer, { anchor: 'left', open: true, slotProps: { paper: { sx: drawerPaperSx } }, sx: { display: { xs: 'none', lg: 'block' } }, variant: 'permanent', children: content })] }));
};
